import { FC } from 'react';
import { Button } from '@nebo-team-dev/vobaza.ui.button';

import { toNumberWithSpaces } from 'shared/lib/formatters';

import styles from './styles.module.scss';

type CartFooterProps = {
  total: number;
  callBack?: () => void;
  isDisable?: boolean;
  buttonText: string;
};
export const CartFooter: FC<CartFooterProps> = ({ total, callBack, isDisable = false, buttonText }) => {
  return (
    <div className={styles.cartFooterWrapper}>
      <p>{toNumberWithSpaces(total)} ₽</p>
      <Button onClick={callBack} type="button" disabled={isDisable} text={buttonText} />
    </div>
  );
};
